import store from '@/vuex/store';
import AppsApi from '@/api/apps-api/apps-api.service';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import amazonAuth from './api-config';

const initCognitoAuth = () => {
  const auth = new CognitoAuth(amazonAuth);

  auth.userhandler = {
    onSuccess: (result) => {
      result.getIdToken().getJwtToken();

      const authorizationToken = result.idToken.jwtToken;
      console.log('result.idToken.jwtToken', authorizationToken);

      store.dispatch('LOGIN_SUCCESS', authorizationToken);
      AppsApi.configure(authorizationToken);
    },
  };

  const curUrl = window.location.href;

  auth.parseCognitoWebResponse(curUrl);

  return auth;
};

const login = (auth) => {
  auth.getSession();
};

const authService = {
  login,
  initCognitoAuth,
};

export default authService;
